import React from "react"
import styled from "@emotion/styled"
import Form from "./Form"
import BackgroundContact from "../global/BackgroundContact"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEnvelope, faPhoneAlt } from "@fortawesome/free-solid-svg-icons"

const Container = styled.div`
  position: relative;
`
const Outer = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  row-gap: 32px;
  grid-template-columns:
    minmax(24px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(24px, auto);
  padding: 64px 0;
`
const BackgroundGrid = styled.div`
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    display: none;
  }
  height: 100%;
  width: 100%;
  display: grid;
  grid-auto-flow: dense;
  row-gap: 32px;
  grid-template-columns:
    minmax(24px, auto) repeat(4, calc(${props => props.theme.maxWidth} / 4))
    minmax(24px, auto);
  position: absolute;
  z-index: -1;
  top: 0;
`
const Card = styled.div`
  background: white;
  grid-row: 1;
  grid-column: 1 / span 4;
  border-radius: 0 8px 8px 0;
`

const Inner = styled.div`
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    padding: 32px 0;
    grid-template-columns: 1fr;
  }
  grid-column: 2;
  min-height: 200px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  align-items: flex-start;
`

const Icon = styled(FontAwesomeIcon)`
  margin-right: 12px;
`
const MicroContact = styled.div`
  margin-bottom: 16px;
`
const Email = styled.a`
  color: ${props => props.theme.primary};
  font-size: 1.2rem;
  display: block;
`
const Phone = styled.a`
  color: ${props => props.theme.primary};
  font-size: 1.2rem;
  margin-top: 8px;
  display: block;
`

const Content = styled.div``
const Text = styled.div`
  font-weight: 600;
`

export default function ContactGrid(props) {
  return (
    <Container data-sal="fade" data-sal-duration="600">
      <Outer>
        <BackgroundGrid>
          <Card />
          <BackgroundContact />
        </BackgroundGrid>
        <Inner>
          <Content>
            <h2>{props.subtitle}</h2>
            <MicroContact>
              <Email href={"tel:" + props.phone}>
                <Icon icon={faPhoneAlt} fixedWidth />
                {props.phone}
              </Email>
              <Phone href={"mailto:" + props.email}>
                <Icon icon={faEnvelope} fixedWidth />
                {props.email}
              </Phone>
            </MicroContact>
            <Text>{props.content}</Text>
          </Content>
          <Form />
        </Inner>
      </Outer>
    </Container>
  )
}
